export default (status, progress) => ({
  get status() {
    return status()
  },

  get progress() {
    return progress()
  },

  get percent() {
    return Math.round(this.progress)
  },

  get label() {
    if (this.status === 'success') return 'Upload complete'
    if (this.status === 'error') return 'Upload failed'
    return 'Uploading'
  },
})
